import { APPEND_CUSTOMERS, SET_CRM_DATA } from "../actions/crmActions";

const initialState = {
  allCustomers: [],
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_CRM_DATA:
      return { ...state, ...payload };
    case APPEND_CUSTOMERS:
      return { ...state, allCustomers: [...state.allCustomers, ...payload] };
    default:
      return state;
  }
};
export default reducer;
